import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BusyIndicator, Button, Icon, IllustratedMessage, MessageStrip, Text, Title } from "@ui5/webcomponents-react";
import { toast } from "sonner";
import { PublicBookingApi } from "../../api/client";

function Shell({ children }) {
  return (
    <div className="public-shell">
      <div className="brand-header">
        <span className="logo" role="img" aria-label="Tennis">🎾</span>
        <h1>Tennis-Software · Stornierung</h1>
      </div>
      <div className="public-card">{children}</div>
    </div>
  );
}

export default function CancelPage() {
  const { token } = useParams();
  const [phase, setPhase] = useState("loading"); // loading | ready | invalid | done
  const [booking, setBooking] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    PublicBookingApi.cancelInfo(token)
      .then((b) => {
        setBooking(b);
        setPhase(b.status === "cancelled" ? "done" : "ready");
      })
      .catch((e) => setPhase(e.response?.status === 404 ? "invalid" : "error"));
  }, [token]);

  const cancel = async () => {
    setBusy(true);
    try {
      const r = await PublicBookingApi.cancel(token);
      setBooking((b) => ({ ...b, status: "cancelled", appointment: r.appointment }));
      setPhase("done");
    } catch {
      toast.error("Stornierung fehlgeschlagen. Bitte versuche es erneut.");
    } finally {
      setBusy(false);
    }
  };

  if (phase === "loading") {
    return (
      <Shell>
        <div className="center-screen"><BusyIndicator active size="L" /></div>
      </Shell>
    );
  }

  if (phase === "invalid") {
    return (
      <Shell>
        <IllustratedMessage name="UnableToLoad" titleText="Link ungültig" subtitleText="Dieser Storno-Link ist ungültig oder abgelaufen." />
      </Shell>
    );
  }

  if (phase === "error") {
    return (
      <Shell>
        <IllustratedMessage name="UnableToLoad" titleText="Verbindungsproblem"
          subtitleText="Der Termin konnte gerade nicht geladen werden. Bitte versuche es später erneut." />
      </Shell>
    );
  }

  if (phase === "done") {
    return (
      <Shell>
        <div className="center-screen">
          <Icon name="accept" style={{ color: "#107e3e", fontSize: "2.5rem" }} />
          <Title level="H2">Termin storniert</Title>
          <Text>{booking?.appointment}</Text>
          <Text className="muted">Der Zeitpunkt ist jetzt wieder freigegeben.</Text>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <div className="center-screen">
        <Title level="H2">Termin stornieren?</Title>
        <Text>{booking?.appointment}</Text>
        <MessageStrip design="Warning" hideCloseButton>
          Diese Aktion gibt den Termin wieder frei und löscht den Google-Kalendereintrag.
        </MessageStrip>
        <Button design="Negative" disabled={busy} onClick={cancel}>
          {busy ? "Wird storniert…" : "Termin verbindlich stornieren"}
        </Button>
      </div>
    </Shell>
  );
}
